import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { ToastProvider } from 'react-toast-notifications'
import Container from 'react-bootstrap/Container';
// import Footer from './components/Footer/Footer';
import Routes from './Routes';
import Menu from './components/Menu/Menu';
import * as actions from './store/actions/index';
import { useDisplayMode } from './theme/displayMode';
import './App.css';

// Custom toast container so toasts always sit above modals, headers and other fixed elements
const ToastContainer = ({ children, hasToasts, ...props }) => (
	<div
		className="app-toast-container"
		style={{
			position: 'fixed',
			top: 0,
			right: 0,
			maxHeight: '100%',
			overflow: 'hidden',
			padding: 8,
			boxSizing: 'border-box',
			pointerEvents: hasToasts ? 'auto' : 'none',
			zIndex: 999999,
		}}
	>
		{children}
	</div>
);

const App = (props) => {
    const { theme, viewMode } = useDisplayMode();
    const [loading, setLoading] = useState(false);
    const [childProps, setChildProps] = useState();

    useEffect(() => {
        const checkAuth = async () => {
		setLoading(true);
		props.onCheckSignin();		
		setChildProps({isAuthenticated: props.isAuthenticated});				
		setLoading(false); 
    }
        checkAuth();
    }, [])


	const isLogin = props.location && props.location.pathname === '/login';
	const showMenu = viewMode !== 'wall' && (props.isAuthenticated || !isLogin);

	return (           
		<div className={`App${props.isAuthenticated && viewMode !== 'wall' ? ' has-sidebar' : ''}${!showMenu && isLogin ? ' is-login' : ''}${viewMode === 'wall' ? ' is-wall' : ''}${theme === 'dark' ? ' is-dark' : ''}`}>   
			{showMenu ? <Menu {...props} /> : null}
							
			<Container className="px-4 app-main" >
			<ToastProvider autoDismiss
				autoDismissTimeout={3000}
				placement="top-right"
				components={{ ToastContainer }}> 
			{ (!loading) ? (									                            
			<Routes childProps={childProps} {...props} />   
			):''}                       
			</ToastProvider>
			</Container>
			{/* <Footer /> */}
		</div>
        );

}

const mapStateToProps = state => {
    return {
        isAuthenticated: state.auth.token !== null,
        authRedirectPath: state.auth.authRedirectPath,
		userFullname: state.auth.userFullname,
		user: state.auth.user,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onLogout: () => dispatch(actions.logout()),
		onCheckSignin: () => dispatch(actions.authCheckState() ),
		onSetAuthRedirectPath: (path) => dispatch(actions.setAuthRedirectPath(path))
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps )(App));